import axios, { AxiosResponse } from 'axios';

import { Categories } from '../data';
import { ApiBase, generalErrorLogging } from '.';

export const getAssetsOfCategory = async <T>(
    category: keyof typeof Categories
): Promise<Array<T>> => {
    return (
        axios
            // Note: Backend defaults to limit=100 and restricts limit <= 1000.
            // Currently pagination/filtering/sorting is done on the FE.
            .get(`${ApiBase}/${category}?limit=1000&sort=date:desc`) // limit to top 1000 most recent (this is working around lack of pagination)
            .then((resp) => resp.data?.items)
            .catch((e) => generalErrorLogging(e))
    );
};

export const getAsset = async <T>(category: keyof typeof Categories, id: string): Promise<T> => {
    return axios
        .get(`${ApiBase}/${category}/${id}`)
        .then((resp) => resp.data)
        .catch((e) => generalErrorLogging(e));
};

export const createAsset = async <T>(
    category: keyof typeof Categories,
    data: T
): Promise<AxiosResponse<void>> => {
    return axios.post(`${ApiBase}/${category}`, data).catch((e) => generalErrorLogging(e));
};

export const updateAsset = async <T>(
    category: keyof typeof Categories,
    id: string,
    data: T
): Promise<AxiosResponse<void>> => {
    return axios.put(`${ApiBase}/${category}/${id}`, data).catch((e) => generalErrorLogging(e));
};

export const deleteAsset = async (
    category: keyof typeof Categories,
    id: string
): Promise<AxiosResponse<void>> => {
    return axios.delete(`${ApiBase}/${category}/${id}`).catch((e) => generalErrorLogging(e));
};
